<template>
    <div :style="{'min-height':minHeight}"  style="width:100%;background-color:rgba(0, 0, 0, 0.05);display: flex;flex-direction: column;align-items: center;justify-content: center;">
        <div style="width:500px;padding:0px 10px;background-color: #fff;font-size: 14px;box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);border-radius: 3px;">
            <el-row style="height: 50px;color:#c40001;font-weight: 700;line-height: 50px;border-bottom: 2px dotted #2d8cf0;">
                重置密码
            </el-row>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm"  class="demo-ruleForm" style="padding: 0 30px 0 20px;">
                <el-form-item 
                    style="margin-top:40px;"
                    label="邮箱" 
                    label-width="100px"
                    prop="email"
                >
                    <el-input placeholder="请输入邮箱" autocomplete="off"  v-model="ruleForm.email" clearable></el-input>
                </el-form-item>

                <el-form-item 
                    style="margin-top:40px;position: relative;"
                    label="邮箱验证码" 
                    label-width="100px"
                    prop="vifyCode"
                >
                    <el-input style="width:200px;" placeholder="请输入验证码" v-model="ruleForm.vifyCode" clearable></el-input>
                    <el-button style="width:110px;background-color: #c40001;border-color:#c40001;" type="primary" :disabled="isButtonDisabled" @click="getVierificationCode()">{{buttonText}}</el-button>
                </el-form-item>

                <el-form-item 
                    style="margin-top:40px;"
                    label="新密码" 
                    label-width="100px"
                    prop="password"
                >
                    <el-input placeholder="请输入密码" autocomplete="off"  v-model="ruleForm.password" show-password clearable></el-input>
                </el-form-item>

                <el-form-item 
                    style="margin-top:40px;"
                    label="确认密码" 
                    label-width="100px"
                    prop="checkPassword"
                >
                    <el-input placeholder="请输入密码" autocomplete="off" v-model="ruleForm.checkPassword" show-password clearable></el-input>
                </el-form-item>               

                <el-form-item label-width="0" style="margin-top:40px;display: flex;justify-content: center;align-items: center;">
                    <el-button style="width:200px;background-color: #c40001;border-color:#c40001;" type="primary" @click="submitForm('ruleForm')">提交</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
    export default{
        name:'ForgetPassword',
        data(){
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                callback(new Error('请输入密码'));
                } else {
                if (this.ruleForm.checkPassword !== '') {
                    this.$refs.ruleForm.validateField('checkPassword');
                }
                callback();
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                callback(new Error('请再次输入密码'));
                } else if (value !== this.ruleForm.password) {
                callback(new Error('两次输入密码不一致!'));
                } else {
                callback();
                }
            };
            return{
                ruleForm: {
                    email: '',
                    password:'',
                    checkPassword:'',
                    vifyCode:'',
                },
                uuid:'',                
                rules: {
                        email: [
                            { required: true, message: '请输入邮箱', trigger: 'blur' },
                        ],
                        password: [
                            { validator: validatePass,required: true, trigger: 'blur' }
                        ],
                        checkPassword: [
                            { validator: validatePass2,required: true, trigger: 'blur' }
                        ],                       

                        vifyCode: [
                            { required: true, message: '请输入验证码', trigger: 'blur' },
                        ],

                },
                minHeight:'100%',
                //发送验证码相关
                countdown: 0, // 倒计时秒数
                isButtonDisabled: false, // 按钮是否禁用
                buttonText: '发送验证码', // 按钮文本
            }
        },
        methods:{
            submitForm:function(formName) {
                var that=this;
                this.$refs[formName].validate((valid) => {
                if (valid) {
                        //注册 调用API
                        var arr = [];
                        var jsont = { "uuid": this.uuid, "ruleForm": this.ruleForm};
                        arr.push(jsont);

                        this.$axios.post(
                            this.Global.globalUrl+'/interface/forgetPassword.ashx',
                            JSON.stringify(arr),
                            {
                                //header: { 'content-type': 'application/x-www-form-urlencoded' }
                                headers:{
                                    'token':JSON.stringify(this.getToken())
                                }

                            })
                        .then((res) => {
                            if (res.data.err==0){
                                this.$message({
                                    showClose:true,
                                    duration:5000,
                                    type: 'success',
                                    message: '重置成功,请登陆!'
                                });
                                //路由到登录
                                this.$router.push({name: "Login"});  
                            }else{
                                this.$message({
                                    showClose:true,
                                    duration:5000,
                                    type: 'error',
                                    message: res.data.errMsg
                                });
                            }
                        })
                        .catch(() => {
                        })

                } else {
                    console.log('error submit!!');
                    return false;
                }
                });
            },
            getVierificationCode:function(){
                if (this.ruleForm.email.length == 0){
                    this.$message({                                   
                            duration:2000,
                            type: 'error',
                            message: '邮箱地址不能为空'
                        });
                    return;
                }
                if (!this.validateEmail()){
                    this.$message({                                   
                            duration:2000,
                            type: 'error',
                            message: '邮箱格式不正确'
                        });
                    return;
                }

                var that=this;
                this.$axios.get(this.Global.globalUrl+'/interface/getEmailVierifyCode.ashx',
                    {
                        params:{
                            email:this.ruleForm.email                           
                        },
                        headers:{
                            'token':JSON.stringify(this.getToken())
                        }
                    }
                )
                .then((res) => {
                    if (res.data.err==0){
                        // 禁用按钮
                        this.isButtonDisabled = true;
                        this.$message({
                            showClose:true,
                            duration:2000,
                            type: 'success',
                            message: '发送成功!'
                        });     
                        // 开始倒计时
                        this.startCountdown(res.data.count);                                        
                    }else{
                        this.isButtonDisabled = false;
                        this.$message({                                   
                            duration:5000,
                            type: 'error',
                            message: res.data.errMsg
                        });
                    }
                })
                .catch(() => {
                })
            },

            startCountdown(count) {
                this.countdown = count; // 重置倒计时
                this.buttonText = `${this.countdown}s`;

                const interval = setInterval(() => {
                    this.countdown--;
                    this.buttonText = `${this.countdown}s`;

                    if (this.countdown <= 0) {
                        clearInterval(interval);
                        this.isButtonDisabled = false; // 启用按钮
                        this.buttonText = '发送验证码'; // 重置按钮文本
                    }
                }, 1000);
            },
            //是否有效邮箱
            validateEmail() {
            // 正则表达式验证邮箱格式
                const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                return emailPattern.test(this.ruleForm.email);
            },
            
        },
        mounted(){
            this.$nextTick(function () {
                this.minHeight = (document.documentElement.clientHeight -200)+'px';
            })
        }
    }
</script>